const actionNames = Object.freeze({
  deviceInfo: "deviceInfo",
  loginAccount: "loginAccount",
  getAppInfo: "getAppInfo",
  appInfo: "appInfo",
  getLanguage: "getLanguage",
  language: "language",
  fcmTokenInfo: "fcmTokenInfo",
  notificationInfo: "notificationInfo",
  MTakeTelemedicinePhoto: "MTakeTelemedicinePhoto",
});

export default actionNames;
